import { getContentAccessControlStateFromContent } from './contentAccessControl';
import { AccessControlTypes } from '../constants/AccessControlTypes';
export const getContentAccessSettingsInfoFromContent = contentAccessProperties => {
  var _contentAccessSetting, _contentAccessSetting2;
  const contentAccessControlStateInfo = contentAccessProperties.map(contentAccessProperty => getContentAccessControlStateFromContent(contentAccessProperty));
  const contentAccessSettingsInfo = contentAccessControlStateInfo.reduce((settingsInfo, content) => {
    switch (content.accessControlType) {
      case AccessControlTypes.PUBLIC:
        settingsInfo.contentCountByAccessControlType.public = (settingsInfo.contentCountByAccessControlType.public || 0) + 1;
        break;
      case AccessControlTypes.PASSWORD:
        // Accounts for getContentAccessControlStateFromContent() treating '' as password being selected in <ContentAccessControl /> settings, distinguishing between the initial selection of the option and the public access option
        if (content.accessPassword) {
          settingsInfo.contentCountByAccessControlType.password = (settingsInfo.contentCountByAccessControlType.password || 0) + 1;
        } else {
          settingsInfo.contentCountByAccessControlType.public = (settingsInfo.contentCountByAccessControlType.public || 0) + 1;
        }
        break;
      case AccessControlTypes.SELF_REGISTRATION:
        settingsInfo.contentCountByAccessControlType.selfRegistration = (settingsInfo.contentCountByAccessControlType.selfRegistration || 0) + 1;
        break;
      case AccessControlTypes.ACCESS_GROUP_MEMBERSHIP:
        settingsInfo.contentCountByAccessControlType.accessGroupMembership = (settingsInfo.contentCountByAccessControlType.accessGroupMembership || 0) + 1;
        settingsInfo.agIds = settingsInfo.agIds || {};
        settingsInfo.agIds.accessGroupMembership = [...(settingsInfo.agIds.accessGroupMembership || []), ...content.accessIds];
        break;
      case AccessControlTypes.SSO:
        settingsInfo.contentCountByAccessControlType.sso = (settingsInfo.contentCountByAccessControlType.sso || 0) + 1;
        break;
      case AccessControlTypes.SSO_WITH_ACCESS_GROUPS:
        settingsInfo.contentCountByAccessControlType.ssoWithAccessGroups = (settingsInfo.contentCountByAccessControlType.ssoWithAccessGroups || 0) + 1;
        settingsInfo.agIds = settingsInfo.agIds || {};
        settingsInfo.agIds.ssoWithAccessGroups = [...(settingsInfo.agIds.ssoWithAccessGroups || []), ...content.accessIds];
        break;
      default:
        break;
    }
    return settingsInfo;
  }, {
    contentCountByAccessControlType: {}
  });
  contentAccessSettingsInfo.sharedAccessControlType = Object.keys(contentAccessSettingsInfo.contentCountByAccessControlType).find(accessControlType => contentAccessSettingsInfo.contentCountByAccessControlType[accessControlType] === contentAccessProperties.length);
  if ((_contentAccessSetting = contentAccessSettingsInfo.agIds) !== null && _contentAccessSetting !== void 0 && _contentAccessSetting.accessGroupMembership) {
    contentAccessSettingsInfo.agIds.accessGroupMembership = [...new Set(contentAccessSettingsInfo.agIds.accessGroupMembership)];
  }
  if ((_contentAccessSetting2 = contentAccessSettingsInfo.agIds) !== null && _contentAccessSetting2 !== void 0 && _contentAccessSetting2.ssoWithAccessGroups) {
    contentAccessSettingsInfo.agIds.ssoWithAccessGroups = [...new Set(contentAccessSettingsInfo.agIds.ssoWithAccessGroups)];
  }
  return contentAccessSettingsInfo;
};